import {Component, Inject, OnInit} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SessionService } from "src/app/features/shared/services/Session.service";
import { LocalStorageService } from "src/app/features/shared/services/LocalStorage.service";

import { environment } from "src/environments/environment";
import { FilterDefinition, FilterDialogData, SelectedFilter } from "../../../../../models/Filters";
import { EstatusJSON } from "src/app/features/shared/models/EstatusJSON";
import { forkJoin, of, Subscription } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { FilterMapService } from "../../../../../services/Filter-Map.service";

@Component({
    selector: "filter-map",
    templateUrl: "./filter-map.component.html",
    styleUrls: ["./filter-map.component.css"],
})
export class FilterMapComponent implements OnInit {
    isLoading = true;
    form: FormGroup;
    filters: FilterDefinition[] = [];
    valuesFiltered : SelectedFilter[] = [];

    moduleName: string | null = "";

    idLocationCategory: number = null;

    subscription_GetFilters: Subscription;
    subscription_GetValuesFilters: Subscription;

    constructor(
        public dialogRef : MatDialogRef<FilterMapComponent>,
        private sessionService : SessionService,
        private filterMapService : FilterMapService,
        private localStorageService: LocalStorageService,
        @Inject(MAT_DIALOG_DATA) private data: FilterDialogData) {

        if(!environment.production) console.log('filtersMap data', data);
        
        this.form = new FormGroup({});

        this.valuesFiltered = data.selected ? data.selected.map(s => ({ ...s })) : [];
        this.idLocationCategory = data.idLocationCategory;
        this.moduleName = data.moduleName;

        if (data.filters != null && data.filters.length > 0) {
          var inputFilters = data.filters.map( filter => ({ ...filter, display: filter.display ? filter.display : filter.key, module: filter.module || data.moduleName || '' }) );
          if (data.idLocationCategory != null) {
            inputFilters = data.filters.filter( (f) => f.idLocationCategory == data.idLocationCategory );
          }
          this.filters = inputFilters.sort((a, b) => (a.key < b.key ? -1 : 1));
    
          const group: any = {};
          this.filters.forEach((element) => {
            if (this.valuesFiltered.some((x) => x.key == element.key)) {
              element.selected = this.valuesFiltered[ this.valuesFiltered.findIndex((x) => x.key == element.key) ].value;
            } else {
              element.selected = "";
            }
            group[element.key] = new FormControl(element.selected);
          });
    
          this.form = new FormGroup(group);
          this.isLoading = false;
        } else {
          this.getFilters();
        }
    }

    ngOnInit(): void {
        this.checkingURL();
    }

    ngOnDestroy(): void {
        if(this.subscription_GetFilters) this.subscription_GetFilters.unsubscribe();
        if(this.subscription_GetValuesFilters) this.subscription_GetValuesFilters.unsubscribe();
    }

    checkingURL() {
        this.sessionService.CheckURLSource();
    }

    getFilters() {
    if (!this.moduleName) {
      this.isLoading = false;
      return;
    }

    this.subscription_GetFilters = this.filterMapService.getFiltersByModule(this.moduleName).subscribe({
        next: (data: EstatusJSON) => {
          const filters = data.result;
          if(filters == null || filters.length == 0){
            this.isLoading = false;
            return;
           }

          filters.forEach((element) => element.module = this.moduleName);

          const valueRequests = filters.map((element) =>
            this.filterMapService.getValuesByFilterModule(element.key, this.moduleName).pipe(
              map((res) => ({ element, filterValues: res.result })),
              catchError((error) => {
                console.error("Error al obtener valores de filtros", error);
                return of({ element, filterValues: [] });
              })
            )
          );

          this.subscription_GetValuesFilters = forkJoin(valueRequests).subscribe((results: { element: any, filterValues: any[] }[]) => {
            results.forEach(({ element, filterValues }) => {
              var filterValuesNoEmpty = (filterValues || []).filter(v => v != null && v !== undefined && v.toString().trim() !== '');

              this.filters.push({
                key: element.key,
                display: element.value ? element.value : element.key,
                values: filterValuesNoEmpty,
                idLocationCategory: element.idLocationCategory ? element.idLocationCategory : null,
                module: element.module ? element.module : this.moduleName
              });
            });

            const group: any = {};
            this.filters.forEach((element) => {
              if (this.valuesFiltered.some((x) => x.key == element.key)) {
                element.selected = this.valuesFiltered[  this.valuesFiltered.findIndex((x) => x.key == element.key) ].value;
              } else {
                element.selected = "";
              }
              group[element.key] = new FormControl(element.selected);
            });

            this.form = new FormGroup(group);
            this.isLoading = false;
            if (!environment.production) console.log("Filters", this.filters);
          });
        },
        error: (error) => {
          console.error("Error al obtener filtros por módulo", error);
          this.isLoading = false;
        },
      });
  }

    addFilter($filter: SelectedFilter) {        
        if(this.filters.some(x => x.key == $filter.key)) {
            const valueIndex = this.valuesFiltered.findIndex(x => x.key == $filter.key);
            if(valueIndex == -1){
                this.valuesFiltered.push({key: $filter.key, value: $filter.value, module: $filter.module || ''});
            } else {
                this.valuesFiltered[valueIndex].value = $filter.value;
                this.valuesFiltered[valueIndex].module = $filter.module || '';
            }
        }
    }

    dropFilter($filter: SelectedFilter) {
        const valueIndex = this.valuesFiltered.findIndex(x => x.key == $filter.key);
        if(valueIndex >= 0) {
            this.valuesFiltered.splice(valueIndex, 1);
        }
    }

    clear() {
        this.form.reset();
        this.filters.forEach(element => {
            element.selected = '';
        });
        this.valuesFiltered = [];
        console.log("filters cleared", this.filters, this.valuesFiltered, this.idLocationCategory);
        this.dialogRef.close({ search: true, filtersSelected: this.valuesFiltered, idLocationCategory: this.idLocationCategory });
    }

    cancel(){
        this.dialogRef.close({ search: false });
    }

    accept() {
        this.dialogRef.close({ search: true, filtersSelected: this.valuesFiltered, idLocationCategory: this.idLocationCategory });  
    }
}
